import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

/**
 * Anonymizes a phone number by replacing all digits with * except for the last two digits.
 * The prefix is included if provided.
 * E.g. "+45 ******78"
 * @param data
 * @returns
 */
export const anonymizePhoneNumber = (data: {
  phoneNumber: string;
  phoneNumberPrefix?: string;
}): string => {
  // Replace phone number with *'s, followed by the last two digits
  const anonymousPhoneNumber =
    '*'.repeat(data.phoneNumber?.length - 2) + data.phoneNumber?.slice(-2);

  return `${
    data?.phoneNumberPrefix ? `${data?.phoneNumberPrefix} ` : ''
  }${anonymousPhoneNumber}`;
};

/**
 * Formats a phone number according to the international format.
 * The prefix is included if provided.
 * E.g. "+45 78 87 78 78"
 * @param data
 */
export const formatPhoneNumber = (data: {
  phoneNumber: string;
  phoneNumberPrefix?: string;
}): string => {
  const phoneUtil = PhoneNumberUtil.getInstance();
  try {
    if (data.phoneNumberPrefix) {
      const number = phoneUtil.parseAndKeepRawInput(
        data.phoneNumberPrefix + data.phoneNumber,
      );
      return phoneUtil.format(number, PhoneNumberFormat.INTERNATIONAL);
    } else {
      return data.phoneNumber;
    }
  } catch (error) {
    console.error('Error formatting phone number:', error);
    return data.phoneNumber;
  }
};
